import { ExportOptions, ExportPayloadSection } from '../types';
import isNumericColumn from './isNumericColumn';

const applyDecimalSeparator = (
  value: string,
  column: ExportPayloadSection['columns'][number],
  options: ExportOptions
): string => {
  if (options.decimalSeparator === 'display' || !isNumericColumn(column)) {
    return value;
  }

  const separator = options.decimalSeparator === 'comma' ? ',' : '.';
  const oppositeSeparator = separator === ',' ? '.' : ',';

  // Numeric export formatting only rewrites the decimal separator, not grouping.
  return value.replace(oppositeSeparator, separator);
};

export default applyDecimalSeparator;
